import { render } from "./PageReviews.vue?vue&type=template&id=93f264ac&scoped=true"
import script from "./PageReviews.vue?vue&type=script&lang=js"
export * from "./PageReviews.vue?vue&type=script&lang=js"

import "./PageReviews.vue?vue&type=style&index=0&id=93f264ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93f264ac"]])

export default __exports__